import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ServiceProviderComponent} from './components/service-provider/service-provider.component';

const routes: Routes = [
  {
    path: 'serviceprovider',
    component: ServiceProviderComponent,
    data: {title: 'Service Provider'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ServiceProviderRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/service-provider-routing.module.ts